<template>
    <div>
        <div class="col-sm-12">
            <div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px"
                        >{{ $t('landingPage.settingApplicationMethod.titleBlock') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="applicationForm.title_block"
                            :config.sync="configForm.configFieldTitle"
                            :disabled="!!applicationForm.title_image"
                            @change="handleShotCodeStyle"
                            @blur="handleValidateField(configForm.configFieldTitle)"
                        />
                        <div class="mt-3">
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                                <div class="col-sm-3">
                                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                                        <InputText
                                            style="max-width: 120px"
                                            :model.sync="applicationForm.size_title"
                                            :config.sync="configForm.configFieldSizeTitle"
                                            :disabled="!!applicationForm.title_image"
                                        />
                                        <span>px</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="applicationForm.color_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                            :disabled="!!applicationForm.title_image"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="applicationForm.color_title"
                                            :config="{
                                                error: false
                                            }"
                                            :disabled="!!applicationForm.title_image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="applicationForm.background_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                            :disabled="!!applicationForm.title_image"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="applicationForm.background_title"
                                            :config="{
                                                error: false
                                            }"
                                            :disabled="!!applicationForm.title_image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationMethod.imgTitle') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="applicationForm.title_image"
                            :id="`TitleApplicationImgLP`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('landingPage.noteImageBeautiful') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationMethod.background') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="applicationForm.background_image"
                            :id="`BackgroundImgLPApplicationMethods`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('noteUploadMaxMB') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                        <div class="form-group row mt-2">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="applicationForm.background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="applicationForm.background_color"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <InputCheckBox
                                :model.sync="applicationForm.is_repeat"
                                :id="`check-repeat-background-app_method`"
                                :value="applicationForm.is_repeat"
                                :label="`repeat`"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingApplicationMethod.style') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap" style="gap: 1rem">
                            <div v-for="item in listStyleAppMethods" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="applicationForm.style"
                                    :name="`application-methods-style`"
                                    :id="`application-methods-style-${item.id}`"
                                    :value="item"
                                    :label="item.name"
                                    @change="handleShotCodeStyle('select')"
                                />
                                <div class="mt-2" style="width: 100px; height: 80px">
                                    <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-5">
                    <div class="text-right mb-5">
                        <button type="button" class="btn btn-outline-success btn-sm rounded" @click="handleAddMethodApp()">
                            <i class="fa fa-plus"></i>
                            ステップ追加
                        </button>
                    </div>
                </div>

                <Draggable
                    :list="applicationForm.application_methods"
                    ghost-class="ghost--applicationMethods"
                    class="overflow-hidden"
                    @start="dragList = true"
                    @end="dragList = false"
                    @change="handleShotCodeStyle"
                >
                    <div v-for="(itemAppMethod, k) in applicationForm.application_methods" :key="`appMethods-${k}`" class="card p-2">
                        <div class="card-body position-relative border-bottom">
                            <div class="d-flex flex-row mt-3">
                                <div class="mr-3">
                                    <div class="d-flex align-items-center justify-content-center h-100">
                                        <InputCheckBox
                                            class="custom-switch"
                                            :model.sync="itemAppMethod.status"
                                            :id="`appMethods-${k}`"
                                            :value="true"
                                            :label="``"
                                            @change="handleShotCodeStyle"
                                        />
                                    </div>
                                </div>
                                <div class="mr-3 col-sm-1" style="min-width: 120px">
                                    <img
                                        loading="lazy"
                                        :src="itemAppMethod?.image?.path"
                                        :alt="itemAppMethod?.image?.origin_name"
                                        class="img-fluid mx-auto d-block rounded h-100 w-100"
                                        style="object-fit: contain"
                                    />
                                </div>
                                <div>
                                    <div class="col-sm-12 p-0">
                                        <h4 v-b-tooltip.hover :title="itemAppMethod.title">
                                            {{ truncateTextTable(itemAppMethod.title, 50) ?? '' }}
                                        </h4>
                                    </div>
                                    <div class="col-sm-12 p-0">
                                        <a target="_blank" :href="itemAppMethod.image?.path"
                                            >{{ truncateTextTable(itemAppMethod.image?.path, 300) ?? '' }}
                                        </a>
                                    </div>
                                    <div class="p-1" v-html="truncateTextTable(itemAppMethod.detail, 500) ?? ''"></div>
                                </div>
                            </div>
                            <div class="position-absolute" style="top: 0; right: 0">
                                <button
                                    v-b-tooltip.hover="`${$t('btn.copy')}`"
                                    type="button"
                                    class="btn btn-outline-info btn-sm rounded-circle"
                                    style="width: 30px; height: 30px"
                                    @click="handleCopyMethod(itemAppMethod)"
                                >
                                    <i class="fa fa-copy"></i>
                                </button>
                                <button
                                    v-b-tooltip.hover="`${$t('btn.edit')}`"
                                    type="button"
                                    class="btn btn-outline-warning btn-sm rounded-circle mx-3"
                                    style="width: 30px; height: 30px"
                                    @click="handleEditMethodApp(itemAppMethod, k)"
                                >
                                    <i class="fa fa-edit"></i>
                                </button>
                                <button
                                    v-b-tooltip.hover="`${$t('btn.delete')}`"
                                    type="button"
                                    class="btn btn-outline-danger btn-sm rounded-circle"
                                    style="width: 30px; height: 30px"
                                    @click="handleDeleteMethodApp(k)"
                                >
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>

            <ModalActionAppMethod
                v-if="configModalActionAppMethod.model"
                :config="configModalActionAppMethod"
                :dataTitle="formAppMethod"
                @updateData="eventUpdateDataAppMethod"
                @addData="eventAddDataAppMethod"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { configModalActionAppMethod, STATUS_APPLICATION_METHODS } from './constants';
import { truncateText, tranferShortCode, getCurrentDateTimeFormatted } from '@/utils/format';
import { InputText, InputCheckBox, InputRadio } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { LIST_STYLE_APPLICATION_METHODS } from '../../styles';
import { onHandleChangeTemp, mapImageDefault } from '../../handlers';
import { cloneDeep } from 'lodash';

import ModalActionAppMethod from './modal-action.vue';
import Draggable from 'vuedraggable';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';

export default {
    name: 'SettingApplicationMethod',
    components: {
        ModalActionAppMethod,
        Draggable,
        InputText,
        UploadImageCommon,
        InputCheckBox,
        InputRadio
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage'])
        })
    },

    data() {
        return {
            configModalActionAppMethod: configModalActionAppMethod,
            formAppMethod: null,
            dragList: false,
            isVisibleEditor: false,
            listStyleAppMethods: mapImageDefault(LIST_STYLE_APPLICATION_METHODS),
            applicationForm: cloneDeep(this.dataForm)
        };
    },

    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },

        onHandleMakeId() {
            const handleMakeId =
                this.applicationForm.application_methods.length <= 0
                    ? this.applicationForm.application_methods.length + 1
                    : Math.max(...this.applicationForm.application_methods.map((item) => item.id || item.make_id)) + 1;
            return handleMakeId;
        },

        handleCopyMethod(evtMethod) {
            this.applicationForm.application_methods.push({
                detail: evtMethod.detail,
                image: evtMethod.image,
                make_id: this.onHandleMakeId(),
                status: evtMethod.status,
                title: `${evtMethod.title} Copy ${getCurrentDateTimeFormatted()}`,
                size_method: evtMethod.size_method,
                color_method: evtMethod.color_method,
                background_method: evtMethod.background_method,
                background_item: evtMethod.background_item,
                actionTitle: 'Edit'
            });
            this.handleShotCodeStyle();
        },

        handleAddMethodApp() {
            this.configModalActionAppMethod.title = this.$t('history.register');
            this.formAppMethod = {
                make_id: this.onHandleMakeId(),
                title: '',
                size_method: '20',
                color_method: '',
                background_method: '',
                background_item: '',
                image: null,
                detail: '',
                status: STATUS_APPLICATION_METHODS[0].value
            };
            this.configModalActionAppMethod.model = true;
        },

        handleEditMethodApp(title, idx) {
            this.configModalActionAppMethod.id = title?.id ?? idx;
            this.configModalActionAppMethod.title = '応募方法編集';
            this.formAppMethod = {
                ...title,
                size_method: title.size_method || '20'
            };
            this.configModalActionAppMethod.model = true;
        },

        handleDeleteMethodApp(idx) {
            this.applicationForm.application_methods.splice(idx, 1);
            this.handleShotCodeStyle();
        },

        eventAddDataAppMethod(titleNew) {
            this.applicationForm.application_methods.push(titleNew);
            this.handleShotCodeStyle();
        },
        eventUpdateDataAppMethod(titleNew) {
            const hasConfigId = titleNew?.id ?? titleNew.make_id;
            let indexTitle = this.applicationForm.application_methods.findIndex((item) => {
                const hasIdList = item?.id ?? item.make_id;
                return hasIdList == hasConfigId;
            });
            if (indexTitle <= -1) return;
            this.applicationForm.application_methods[indexTitle] = titleNew;
            this.handleShotCodeStyle();
        },

        truncateTextTable(text, length) {
            return truncateText(text, length);
        },

        handleShotCodeStyle(type = null) {
            if (!this.applicationForm.style) return;
            let contentNew = [];
            let { application_methods } = this.applicationForm;
            let { contents, stepJoin, backgroundColorDefault } = this.applicationForm.style;
            if (type === 'select') this.applicationForm.background_color = backgroundColorDefault ?? '#ffffff';
            application_methods.forEach((itemAppMethod) => {
                const replacements = {
                    タイトル: itemAppMethod.title ?? '',
                    fontSizeMethod: itemAppMethod.size_method ? `${itemAppMethod.size_method}px` : '20px',
                    colorMethod: itemAppMethod.color_method ?? '',
                    bgrColorMethod: itemAppMethod.background_method ?? '',
                    詳細: itemAppMethod.detail ?? '',
                    imgTitle: itemAppMethod.image?.path ?? '',
                    display: itemAppMethod?.status ? 'block' : 'none',
                    backgroundItem: itemAppMethod.background_item ?? ''
                };
                let contentShotCode = tranferShortCode(contents, replacements);
                let stepJoinReplacements = {
                    display: itemAppMethod?.status ? 'block' : 'none'
                };
                let stepJoinShotCode = tranferShortCode(stepJoin, stepJoinReplacements);
                contentNew.push(contentShotCode);
                contentNew.push(stepJoinShotCode);
            });
            let convertContentString = contentNew.join(``);
            let addProper = application_methods?.length > 0 ? convertContentString : '';
            this.applicationForm.html_content = addProper;
        }
    },
    watch: {
        infoSettingLandingPage: {
            handler: function (newSetting) {
                if (this.applicationForm.style) return;
                let checkTem = onHandleChangeTemp(newSetting, this.applicationForm, this.listStyleAppMethods);
                if (checkTem) this.handleShotCodeStyle('select');
            },
            immediate: true,
            deep: true
        },

        dataForm: {
            handler: function (newSetting) {
                this.applicationForm = newSetting;
            },
            immediate: true
        },

        applicationForm: {
            handler: function (newApplicationForm) {
                this.$emit('update:dataForm', newApplicationForm);
            },
            deep: true
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.ghost--applicationMethods {
    opacity: 0.5;
    background-color: #f8f9fa;
    border: dashed 1px #ccc;
}
</style>
